import { useRef, useState } from "react";
import { Heart, Coins, Timer, Star, Trophy, Flame } from "lucide-react";

const options = ["Venus", "Mars", "Jupiter", "Mercury"];

export default function PhoneMockup() {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ rx: 0, ry: 0 });

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    setTilt({ rx: -y * 14, ry: x * 18 });
  };

  return (
    <div
      ref={ref}
      data-testid="phone-mockup-container"
      className="relative"
      style={{ perspective: "1200px" }}
      onMouseMove={onMove}
      onMouseLeave={() => setTilt({ rx: 0, ry: 0 })}
    >
      <div className="absolute left-1/2 top-1/2 -z-10 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#00F0FF]/15 blur-[110px]" />
      <div
        className="relative mx-auto w-[272px] sm:w-[300px]"
        style={{
          transform: `rotateX(${tilt.rx}deg) rotateY(${tilt.ry}deg)`,
          transition: "transform 0.25s ease-out",
          transformStyle: "preserve-3d",
        }}
      >
        <div className="rounded-[2.7rem] border border-[#2b3047] bg-[#0b0d16] p-2 shadow-[0_50px_100px_-20px_rgba(0,240,255,0.25)]">
          <div className="relative overflow-hidden rounded-[2.2rem] bg-[#08090E]">
            <div className="absolute left-1/2 top-2.5 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-black" />
            <div className="px-4 pt-10 pb-5" style={{ height: 560 }}>
              <div className="flex items-center justify-between font-code text-[10px] text-[#64748B]">
                <span>DUEL #4021</span>
                <span className="flex items-center gap-1 text-[#39FF14]">
                  <Timer size={11} /> 00:12
                </span>
              </div>
              <div className="mt-3 flex items-center justify-between">
                <span className="flex items-center gap-1.5">
                  <img src="/assets/logo.png" alt="Quizzy" className="h-5 w-5 rounded-md" />
                  <span className="font-display text-sm font-bold text-white">QUIZZY</span>
                </span>
                <div className="flex items-center gap-2">
                  <span className="flex items-center gap-1 rounded-full bg-[#151824] px-2 py-0.5 text-[10px] text-[#FF007A]">
                    <Heart size={10} fill="#FF007A" /> 3
                  </span>
                  <span className="flex items-center gap-1 rounded-full bg-[#151824] px-2 py-0.5 text-[10px] text-[#39FF14]">
                    <Coins size={10} /> 1.2k
                  </span>
                </div>
              </div>
              <div className="mt-4 h-1.5 overflow-hidden rounded-full bg-[#151824]">
                <div className="h-full w-2/3 rounded-full bg-gradient-to-r from-[#00F0FF] to-[#8A2BE2]" />
              </div>
              <div className="mt-4 rounded-2xl border border-[#222738] bg-[#0F111A] p-4">
                <span className="rounded-full border border-[#00F0FF]/40 px-2.5 py-1 font-code text-[9px] tracking-widest text-[#00F0FF]">
                  SCIENCE
                </span>
                <p className="mt-3 font-sub text-[15px] font-semibold leading-snug text-white">
                  Which planet is known as the Red Planet?
                </p>
              </div>
              <div className="mt-4 space-y-2.5">
                {options.map((o, i) => (
                  <div
                    key={o}
                    className={`flex items-center gap-3 rounded-xl border px-3.5 py-2.5 font-sub text-[13px] ${
                      o === "Mars"
                        ? "border-[#39FF14] bg-[#39FF14]/10 text-[#39FF14] shadow-[0_0_18px_rgba(57,255,20,0.25)]"
                        : "border-[#222738] bg-[#0F111A] text-[#94A3B8]"
                    }`}
                  >
                    <span
                      className={`flex h-6 w-6 items-center justify-center rounded-md font-code text-[10px] ${
                        o === "Mars" ? "bg-[#39FF14] text-[#08090E]" : "bg-[#151824] text-[#64748B]"
                      }`}
                    >
                      {String.fromCharCode(65 + i)}
                    </span>
                    {o}
                  </div>
                ))}
              </div>
              <div className="mt-5 flex items-center justify-between">
                <span className="flex items-center gap-1.5 font-code text-[10px] text-[#FF007A]">
                  <Flame size={12} /> STREAK x7
                </span>
                <div className="rounded-full bg-[#00F0FF] px-6 py-2 font-sub text-xs font-bold text-[#08090E]">
                  NEXT
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="glass absolute -left-16 top-24 flex items-center gap-2 rounded-2xl px-3 py-2 animate-floaty"
          style={{ transform: "translateZ(70px)" }}
        >
          <Star size={14} className="text-[#39FF14]" fill="#39FF14" />
          <span className="font-code text-[10px] text-white">+250 XP</span>
        </div>
        <div
          className="glass absolute -right-14 top-1/2 flex items-center gap-2 rounded-2xl px-3 py-2 animate-floaty"
          style={{ transform: "translateZ(90px)", animationDelay: "1.2s" }}
        >
          <Trophy size={14} className="text-[#FF007A]" />
          <span className="font-code text-[10px] text-white">RANK #12</span>
        </div>
        <div
          className="glass absolute -left-10 bottom-20 rounded-2xl px-3 py-2 animate-floaty"
          style={{ transform: "translateZ(50px)", animationDelay: "2s" }}
        >
          <span className="font-code text-[10px] text-[#00F0FF]">8/10 CORRECT</span>
        </div>
      </div>
    </div>
  );
}
